import { render, staticRenderFns } from "./TabelaCadastrosVuetfy.vue?vue&type=template&id=54e55e5d"
import script from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"
export * from "./TabelaCadastrosVuetfy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports